// @flow
import * as React from 'react';
// eslint-disable-next-line import/named
import type { IntlShape } from 'react-intl';
import cn from 'classnames';
import LoaderHOC from 'components/atoms/LoaderHOC';

// Components
import Button from 'components/atoms/Button';
import Modal from 'components/atoms/Modal';
import ParseHTML from 'components/atoms/ParseHTML';

// Utils
import { isUrl } from 'utils/string';

import TermsPrivacyLoader from './TermsPrivacyLoader';
import './TermsPrivacy.scss';

// Constants
import { APP_NAMES } from 'constants/appName';

const { CONSUMER_8 } = APP_NAMES;

type OwnProps = {
  intl: IntlShape,
  title: string,
  titleKey: string,
  content: string,
  contentKey: string,
  className: string,
  isTerms: boolean
};

type Props = OwnProps;

class TermsPrivacy extends React.Component<Props> {
  static block = 'terms-privacy';

  static defaultProps = {
    content: 'Discounts are subject to change without notice.'
  };

  constructor(props: Props, context: any) {
    super(props, context);
    (this: any).modal = React.createRef();
    this.getRecaptchaTerms = this.getRecaptchaTerms.bind(this);
  }

  modal: React.Ref<any>;

  getRecaptchaTerms = function() {
    const { appName, intl } = this.props;
    const ns = TermsPrivacy.block;

    if (appName === CONSUMER_8) {
      return (
        <div className={`${ns}__recaptcha-terms`}>
          <ParseHTML
            html={intl.formatMessage({
              id: 'c8.recaptcha.terms.of.services',
              defaultMessage:
                'This site is protected by reCAPTCHA and the Google ' +
                '<a href="https://policies.google.com/privacy">Privacy Policy</a> and ' +
                '<a href="https://policies.google.com/terms">Terms of Service</a> apply.'
            })}
          />
        </div>
      );
    }
  };

  render() {
    const {
      intl,
      title,
      titleKey,
      content,
      contentKey,
      className,
      isTerms
    } = this.props;
    const ns = TermsPrivacy.block;
    const classProps = cn(ns, className);
    const classPropsButton = cn(`${ns}__button`, `${className}__button`);
    const titleStr = titleKey
      ? intl.formatMessage({
          id: titleKey
        })
      : title;
    const contentStr = contentKey
      ? intl.formatMessage({ id: contentKey })
      : content;
    const ariaCloseId = isTerms
      ? 'c8.aria.close.terms.modal'
      : 'c8.aria.close.privacy.modal';
    const ariaCloseDefault = isTerms
      ? 'Close Terms and Conditions Modal'
      : 'Close Privacy Policy Modal';

    return (
      <div className={classProps}>
        <Button
          buttonTheme="link"
          className={classPropsButton}
          onClick={() => {
            if (isUrl(contentStr)) {
              window.open(contentStr);
            } else {
              (this: any).modal.current.setShowModal(true);
            }
          }}
          tabIndex={0}
        >
          {titleStr}
        </Button>
        <Modal
          ref={this.modal}
          title={() => <h1 className={`${ns}__aria-main-title`}>{titleStr}</h1>}
          ariaCloseId={ariaCloseId}
          ariaCloseDefault={ariaCloseDefault}
        >
          <LoaderHOC
            serviceId={'data'}
            placeHolderType={() => <TermsPrivacyLoader />}
            component={() => (
              <div>
                <ParseHTML html={contentStr} />
                {this.getRecaptchaTerms()}
              </div>
            )}
          />
        </Modal>
      </div>
    );
  }
}

export default TermsPrivacy;



// WEBPACK FOOTER //
// ./src/components/pages/components/ContentFooter/components/TermsPrivacy/TermsPrivacy.js